export default {
	DEFAULT: 'default',
	RAW: 'raw',
}
